import { Notify } from 'quasar'

// Notify.setDefaults({
//   actions: [{ label: 'chiudi', color: 'white' }]
// })

Notify.registerType('negative', {
  position: 'bottom-right',
  icon: 'mdi-alert-circle',
  color: 'negative',
})

Notify.registerType('warning', {
  icon: 'mdi-alert',
  color: 'amber',
  textColor: 'black',
})

Notify.registerType('info', {
  color: 'primary',
  icon: 'mdi-information',
})
